import URLS from "../../../../util/urls";
import axios from 'axios';

const state = {
  titulos: [],
}

const mutations = {
  atualizarTitulos(state, payload) {
    state.titulos = payload;
    state.titulos = state.titulos.map(item => { return item.recibo ? item.recibo : item.boletoAvulso })
    state.titulos = state.titulos.map(item => { return { ...item, selecionado: false }});
  },

  selecionarTodos(state){
    state.titulos = state.titulos.map(item => { return { ...item, selecionado: true }});
  },
  deselecionarTodos(state){
    state.titulos = state.titulos.map(item => { return { ...item, selecionado: false }});
  },
}

const actions = {
  selecionarTodos(context) {
    context.commit('selecionarTodos');
  },
  deselecionarTodos(context) {
    context.commit('deselecionarTodos');
  },
  
  listarTitulos(context, payload) {
    return axios.post(URLS.REMESSAS_LISTAR_BOLETOS_REMESSA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarTitulos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarTitulos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  registrarTitulos(context, payload) {
    let url = undefined;
    
    switch (payload.contaBancaria.banco) {
      case "ASAAS":
        url = URLS.TITULOS_API_REGISTRAR_ASAAS;
        break;
      case "CORA":
        url = URLS.TITULOS_API_REGISTRAR_CORA;
        break;
    }

    return axios.post(url, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('registrarTitulos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}